import { AllowEmptyMatcherProperties } from "./AllowEmptyMatcher";
import { DlfMatcher, DlfMatcherProperties } from "./DlfMatcher";

type AllowEmptyDlfMatcherProperties = {} & AllowEmptyMatcherProperties &
  DlfMatcherProperties;

abstract class AllowEmptyDlfMatcher
  extends DlfMatcher
  implements AllowEmptyDlfMatcherProperties
{
  abstract allowEmpty: boolean;

  toggleAllowEmpty(): boolean {
    this.setAllowEmpty(!this.getAllowEmpty());
    return this.getAllowEmpty();
  }
  setAllowEmpty(value: boolean): void {
    this.allowEmpty = value;
  }
  getAllowEmpty(): boolean {
    return this.allowEmpty;
  }

  supportsAllowEmpty(): boolean {
    return true;
  }
}

export { AllowEmptyDlfMatcher, AllowEmptyDlfMatcherProperties };
